import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class NomineeCard extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
  }
  view() {
    const nominee = this.attrs.nominee;
    const category = this.attrs.category;
    const award = this.attrs.award;
    const currentUserId = app.session.user?.id();
    const userVotes = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      return !vUserId || String(vUserId) === String(currentUserId);
    });
    const nomineeId = nominee.id();
    const categoryId = category.id();
    const userVote = userVotes.find(v => {
      const vNomineeId = v.nomineeId?.() || v.data?.relationships?.nominee?.data?.id;
      const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
      return String(vNomineeId) === String(nomineeId) && String(vCategoryId) === String(categoryId);
    });
    const isVoted = !!userVote;
    const canVote = award.isVotingOpen() && app.session.user;
    const showVotes = award.canShowVotes();

    // Tıklanabilir mi kontrolü
    const isClickable = canVote && !this.loading;
    return m("div", {
      className: `NomineeCard ${isVoted ? 'NomineeCard--voted' : ''} ${isClickable ? 'NomineeCard--clickable' : ''} ${this.loading ? 'NomineeCard--loading' : ''}`,
      onclick: isClickable ? () => this.toggleVote(nominee, category, userVote) : undefined,
      role: isClickable ? 'button' : undefined,
      tabindex: isClickable ? 0 : undefined,
      onkeydown: isClickable ? e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleVote(nominee, category, userVote);
        }
      } : undefined
    }, m("div", {
      className: "NomineeCard-image"
    }, nominee.imageUrl() ? m("img", {
      src: nominee.imageUrl(),
      alt: nominee.name(),
      loading: "lazy"
    }) : m("div", {
      className: "NomineeCard-placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), isVoted ? m("div", {
      className: "NomineeCard-check"
    }, m("i", {
      className: "fas fa-check"
    })) : null, nominee.url?.() ? m("a", {
      className: "NomineeCard-link",
      href: nominee.url(),
      target: "_blank",
      rel: "noopener noreferrer",
      title: app.translator.trans('huseyinfiliz-awards.forum.nominee.open_link'),
      onclick: e => {
        e.stopPropagation();
      }
    }, m("i", {
      className: "fas fa-external-link-alt"
    })) : null), m("div", {
      className: "NomineeCard-content"
    }, m("h3", {
      className: "NomineeCard-title"
    }, nominee.name()), nominee.description() ? m("p", {
      className: "NomineeCard-description"
    }, nominee.description()) : null, showVotes ? m("div", {
      className: "NomineeCard-stats"
    }, m("span", {
      className: "NomineeCard-votes"
    }, app.translator.trans('huseyinfiliz-awards.forum.results.votes', {
      count: nominee.voteCount() || 0
    }))) : null, this.loading ? m("div", {
      className: "NomineeCard-loading"
    }, m("i", {
      className: "fas fa-spinner fa-spin"
    })) : null));
  }
  updateCategoryUserVoteIds(category) {
    // Update the category's userVoteIds based on current votes in store
    const categoryId = category.id();
    const currentUserId = app.session.user?.id();
    const userVotesInCategory = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      const isCurrentUser = !vUserId || String(vUserId) === String(currentUserId);
      const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
      return isCurrentUser && String(vCategoryId) === String(categoryId);
    });
    const userVoteIds = userVotesInCategory.map(v => {
      return v.nomineeId?.() || v.data?.relationships?.nominee?.data?.id;
    }).filter(Boolean);
    category.pushData({
      attributes: {
        userVoteIds: userVoteIds
      }
    });
  }
  toggleVote(nominee, category, userVote) {
    if (!app.session.user) {
      return;
    }
    const categoryId = category.id();
    const votesLimit = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10);

    // If user already voted for this nominee, remove the vote
    if (userVote) {
      this.loading = true;
      m.redraw();
      userVote.delete().then(() => {
        // Decrement vote count for the nominee
        const currentVoteCount = nominee.voteCount?.() || 0;
        if (currentVoteCount > 0) {
          nominee.pushData({
            attributes: {
              voteCount: currentVoteCount - 1
            }
          });
        }

        // Update category's userVoteIds
        this.updateCategoryUserVoteIds(category);
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('huseyinfiliz-awards.forum.voting.vote_removed'));
        this.loading = false;
        m.redraw();
      }).catch(e => {
        this.loading = false;
        m.redraw();
        throw e;
      });
      return;
    }

    // Adding a new vote - check limits for multi-vote mode
    const currentUserId = app.session.user?.id();
    const existingVotesInCategory = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      const isCurrentUser = !vUserId || String(vUserId) === String(currentUserId);
      const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
      return isCurrentUser && String(vCategoryId) === String(categoryId);
    });

    // Check if at limit (votesLimit > 0 means there's a limit, 0 = unlimited)
    if (votesLimit > 0 && existingVotesInCategory.length >= votesLimit && votesLimit !== 1) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-awards.forum.error.vote_limit_reached', {
        limit: votesLimit
      }));
      return;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/award-votes',
      body: {
        data: {
          attributes: {
            nomineeId: nominee.id()
          }
        }
      }
    }).then(response => {
      // Only remove existing votes in single-vote mode (votesLimit === 1)
      if (votesLimit === 1) {
        existingVotesInCategory.forEach(v => {
          const prevNomineeId = v.nomineeId?.() || v.data?.relationships?.nominee?.data?.id;
          if (prevNomineeId && String(prevNomineeId) !== String(nominee.id())) {
            const prevNominee = app.store.getById('award-nominees', String(prevNomineeId));
            if (prevNominee) {
              const currentCount = prevNominee.voteCount?.() || 0;
              if (currentCount > 0) {
                prevNominee.pushData({
                  attributes: {
                    voteCount: currentCount - 1
                  }
                });
              }
            }
          }
          app.store.remove(v);
        });
      }

      // Increment vote count for newly voted nominee
      const currentVoteCount = nominee.voteCount?.() || 0;
      nominee.pushData({
        attributes: {
          voteCount: currentVoteCount + 1
        }
      });
      app.store.pushPayload(response);

      // Update category's userVoteIds
      this.updateCategoryUserVoteIds(category);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-awards.forum.voting.vote_saved'));
      this.loading = false;
      m.redraw();
    }).catch(e => {
      this.loading = false;
      m.redraw();
      throw e;
    });
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/NomineeCard', NomineeCard);